import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, finalize, shareReplay, timeout } from 'rxjs';

@Injectable()
export class DashboardGlobalStatisticsRequestInterceptor implements HttpInterceptor {
    private inFlightRequest?: Observable<HttpEvent<unknown>>;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.method !== 'GET' || !request.url.endsWith('/api/services/app/TenantDashboard/GetGlobalStatistics')) {
            return next.handle(request);
        }

        if (!this.inFlightRequest) {
            this.inFlightRequest = next.handle(request).pipe(
                timeout(115_000),
                finalize(() => this.inFlightRequest = undefined),
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }

        return this.inFlightRequest;
    }
}
